import { render, staticRenderFns } from "./ComponentAveragesChartContainer.vue?vue&type=template&id=32fac66a&scoped=true&"
import script from "./ComponentAveragesChartContainer.vue?vue&type=script&lang=js&"
export * from "./ComponentAveragesChartContainer.vue?vue&type=script&lang=js&"
import style0 from "./ComponentAveragesChartContainer.vue?vue&type=style&index=0&id=32fac66a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fac66a",
  null
  
)

export default component.exports